export const isCourseComingSoon = (course) => {
    if (!course || !course.state) {
        return false;
    }

    return course?.state?.indexOf('coming') !== -1;
}

export const isCourseComing2023 = (course) => course?.state === 'coming2023';
export const isCourseComing2024 = (course) => course?.state === 'coming2024';

export const extractAmountVideos = (courses) => {
    let amountVideos = 0;
    let durationVideos = 0;

    for (const course of courses) {

        let courseTotalVideos = course.videoSection?.reduce(
            (acc, cur) => {
                return acc + cur.videos.length
            },
            0
        );

        amountVideos += courseTotalVideos;

        let courseTotalDuration =  course.videoSection?.reduce(
            (acc, cur) => acc + cur.videos.reduce( (acc2, cur2) => acc2 + cur2.duration, 0 ), 0
        )

        durationVideos += courseTotalDuration;

    }

    return {
        amountVideos,
        durationVideos
    }
}
